import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import {
  Backdrop,
  Box,
  Fade,
  IconButton,
  Modal,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

import useStore from './../store'
import LocationDetailsPanel from './../LocationDetailsPanel'
import FaqPanel from './../FaqPanel'
import DataControlsPanel from '../DataControlsPanel'
import OverlaysPanel from '../OverlaysPanel'

// Styles for this component.
const useStyles = makeStyles(theme => ({
  root: {
    // so scrolling works as expected
    '& .panel-root': {
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    },

    zIndex: theme.extras.slideoutPanel.zIndex,
    backgroundColor: theme.palette.background.paper,
    position: 'absolute',
    top: 0,
    left: `-${theme.extras.slideoutPanel.width}px`,
    transition: 'left 200ms linear',
    width: theme.extras.slideoutPanel.width,
    // Adjust for different app bar height.
    height: `calc(100vh - ${theme.mixins.toolbar['@media (min-width:0px) and (orientation: landscape)'].minHeight}px)`,
    top: `${theme.mixins.toolbar['@media (min-width:0px) and (orientation: landscape)'].minHeight}px`,
    [theme.breakpoints.up('sm')]: {
      height: `calc(100vh - ${theme.mixins.toolbar['@media (min-width:600px)'].minHeight}px)`,
      top: `${theme.mixins.toolbar['@media (min-width:600px)'].minHeight}px`,
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
    boxShadow: theme.shadows[3],
  },
  active: {
    left: `${theme.extras.controlPanel.width}px`,
  },
  modal: {
    // so scrolling works as expected
    '& .panel-root': {
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    },

    inset: `${theme.spacing(4)}px !important`,
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
    boxShadow: theme.shadows[3],
    outline: 0,
  },
  modalContent: {
    //border: '1px solid #000',
    outline: 0,
    backgroundColor: theme.palette.background.paper,
    height: '100%',
    borderRadius: '5px',
    overflow: 'hidden',
  },
  button: {
    padding: theme.spacing(2),
    margin: theme.spacing(1),
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 3000,
  },
}))

const SlideoutPanel = () => {
  // console.log('SlideoutPanel()')
  // Generic store value setter.
  const setStoreValues = useStore(
    state => state.setStoreValues,
  )
  const slideoutPanel = useStore(
    state => state.slideoutPanel,
  )

  const handleClose = () => {
    setStoreValues({
      slideoutPanel: { ...slideoutPanel, active: false },
    })
  }

  const classes = useStyles()

  const ActivePanel =
    {
      location: LocationDetailsPanel,
      faq: FaqPanel,
      control: DataControlsPanel,
      overlays: OverlaysPanel,
    }[slideoutPanel.panel] || React.Fragment

  return (
    <>
      <Box
        className={clsx('panel-slideout', classes.root, {
          [classes.active]:
            slideoutPanel.active &&
            slideoutPanel.panel !== 'chart',
        })}
      >
        <IconButton
          onClick={handleClose}
          className={clsx(classes.button)}
        >
          <CloseIcon />
        </IconButton>
        <ActivePanel />
      </Box>

      <Modal
        className={clsx(
          'slideout-panel-modal',
          classes.modal,
        )}
        open={
          slideoutPanel.active &&
          // mobile uses different control panel
          slideoutPanel.panel !== 'control'
        }
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={slideoutPanel.active}>
          <Box className={classes.modalContent}>
            <IconButton
              onClick={handleClose}
              className={clsx(classes.button)}
            >
              <CloseIcon />
            </IconButton>
            <ActivePanel />
          </Box>
        </Fade>
      </Modal>
    </>
  )
}

SlideoutPanel.propTypes = {}

SlideoutPanel.defaultProps = {}

export default SlideoutPanel
